<div class="container-fluid main_container">

  <mat-sidenav-container #drawerContainer (backdropClick)="close()" [hasBackdrop]="mode === 'over' ? true : false">
    <mat-sidenav #sidenav [opened]="toggleSideNav" [disableClose]="true" [mode]="mode"
      *ngIf="!matchUrl('/signin')" class="side-nav side-block" [class.is-collapsed]="sideCollapsed"
      (keydown.escape)="close()">
      <div class="sidenave-items ">
        <div class="logo-wrapper">
          <div class="logo-container">
            <img (click)="toggle()" src="{{dataManager.logoUrl }}" class="logo-img"
              *ngIf="dataManager.brandingReady && dataManager.logoUrl" alt="Logo">
          </div>
          <button type="button" class="drawer-close-btn" aria-label="Close menu" (click)="close()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              [innerHTML]="closeSvg()"></svg>
          </button>
        </div>

        <div class="sidebar-account-loader loader loader--style8" title="loading"
          *ngIf="mode === 'over' && !currentAccountName && menuName == 'Home'">
          <img src="../../../assets/images/uploading.svg">
        </div>
        <div class="sidebar-account" *ngIf="mode === 'over' && currentAccountName">
          <button type="button" class="sidebar-account__trigger" [matMenuTriggerFor]="accountMenu">
            <span class="sidebar-account__label">{{activeUser?.dba_name ? activeUser.dba_name :
              (activeUser?.mid || activeUser?.account_name || currentAccountName)}}</span>
            <svg class="sidebar-account__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" [innerHTML]="caretSvg()"></svg>
          </button>
        </div>
        <mat-menu #accountMenu="matMenu" class="pa-sidebar-menu-panel pa-account-menu-panel" xPosition="after">
          <div class="pa-menu-header" (click)="$event.stopPropagation()">
            {{activeUser?.dba_name ? activeUser?.dba_name + ' - ' : ''}}{{currentAccountName}}{{activeUser?.mid ? ' - '
            + activeUser?.mid : ''}}
          </div>
          <input class="pa-menu-filter" #myInput placeholder="Filter by name" [(ngModel)]="name"
            (focus)="name = null" (click)="$event.stopPropagation()"
            (keydown)="$event.key !== 'Escape' && $event.stopPropagation()">
          <div class="pa-menu-scroll">
            <button mat-menu-item *ngFor="let account of currentUsers | search:'account_name,mid,dba_name':name"
              (click)="switchAccount(account.id, account.account_name)"
              [class.activeAccount]="account.id === currentAccountId">
              {{account.dba_name ? account.dba_name + ' - ' : ''}}{{account.account_name ? account.account_name :
              account.id}}{{account.mid ? ' - ' + account.mid : ''}}
            </button>
          </div>
        </mat-menu>

        <nav class="nav-groups" #navGroups (scroll)="updateNavGroupsFade()" [class.nav-groups--fade-bottom]="navGroupsCanScrollDown">
          <!-- #navGroupsInner exists so there's one real element whose own box size grows
               and shrinks with the *ngFor content below, for NavDrawerComponent's
               ResizeObserver to watch — .nav-groups itself is a flex child with a stable
               viewport-driven height, so adding/removing menu items changes its
               scrollHeight but never its own observable border-box size. -->
          <div #navGroupsInner>
            <ng-container *ngFor="let group of menuGroups; trackBy: trackByGroupLabel">
              <div class="nav-section-label">{{group.label}}</div>
              <ul class="no-padding">
                <li class="main-list" *ngFor="let menu of group.items; trackBy: trackByMenuName"> <!--menuList-->
                  <a class="side-nav-menu menu_list" (click)="myMenuClick(menu);clearFiltersFromLocal()"
                    [routerLink]="menu.routes" routerLinkActive="link-active" [title]="menu.name"
                    *ngIf="menu.subMenu === null">
                    <div class="icons"><svg class="menu-icons" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" [innerHTML]="iconSvg(menu.name)"></svg></div>
                    <div class="icon_label"> {{menu.name}}</div>
                  </a>
                  <a class="side-nav-menu menu_list nav-group-toggle" [class.is-open]="ActiveMenu === menu.name"
                    *ngIf="menu.subMenu != null" [routerLink]="menu.routes" routerLinkActive="link-active"
                    [title]="menu.name" (click)="menuClick(menu);clearFiltersFromLocal()">
                    <div class="icons"> <svg class="menu-icons" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" [innerHTML]="iconSvg(menu.name)"></svg></div>
                    <div class="icon_label">{{menu.name}}</div>
                    <svg class="nav-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" [innerHTML]="caretSvg()"></svg>
                  </a>
                  <ul *ngIf="menu.subMenu != null ? menu.subMenu[0].routerLink=== 'batch-detail'? false: true :''"
                    class="submenu-container" [ngStyle]="{'display': (ActiveMenu === menu.name ? 'block' : 'none')} ">
                    <li *ngFor="let submenu of menu.subMenu" class="submenu-li">
                      <a class="submenu" [routerLink]="submenu.routerLink" routerLinkActive="link-active-sub"
                        (click)="clickedSubmenu(submenu);clearFiltersFromLocal()">
                        <span class="submenu-text">{{submenu.name}}</span></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </ng-container>
          </div>
        </nav>
        <div class="sidebar-profile" *ngIf="mode === 'over' && userName">
          <button type="button" class="sidebar-profile__trigger" [matMenuTriggerFor]="profileMenu">
            <span class="sidebar-profile__avatar">{{(userNameIcon || '') | camalizeStr}}</span>
            <span class="sidebar-profile__label">{{(userName || '') | camalizeStr}}</span>
          </button>
        </div>
        <mat-menu #profileMenu="matMenu" class="pa-sidebar-menu-panel pa-profile-menu-panel" xPosition="after"
          yPosition="above">
          <div class="pa-menu-header" (click)="$event.stopPropagation()">
            <div class="pa-menu-header__name">{{(userName || '') | camalizeStr}}</div>
            <div class="pa-menu-header__email">{{userEmail}}</div>
          </div>
          <button mat-menu-item (click)="myprofile()">Profile</button>
          <button mat-menu-item (click)="toUpdateContact()">Contact</button>
          <button mat-menu-item class="pa-menu-signout" (click)="signOut()">
            <img src="../../../assets/images/sign_out_icon.png" class="siginout_icon" alt="sign out icon">
            Signout
          </button>
        </mat-menu>

        <button type="button" class="side-collapse-btn" (click)="toggleSideCollapse()"
          [attr.aria-label]="sideCollapsed ? 'Expand menu' : 'Collapse menu'"
          [attr.title]="sideCollapsed ? 'Expand menu' : 'Collapse menu'">
          <svg class="side-collapse-btn__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-linecap="round" stroke-linejoin="round" [innerHTML]="collapseSvg()"></svg>
          <span>Collapse</span>
        </button>
        <p class="p_vers">Version 2.0</p>
      </div>

    </mat-sidenav>

    <mat-sidenav-content class=" right_content_block " [ngClass]="{'w-100 mobile_view_right': matchUrl('/signin') }">
      <div class="app-loader" *ngIf="loadFlag">
        <img src="../../../assets/images/loader2.svg">
      </div>

      <div #routerOutlet class="page-container">
        <!-- Sticky inside the scroll container (not a flex sibling above it) so page content
             actually scrolls underneath it — that overlap is what makes the scrolled frosted-glass
             background (.pa-topbar--scrolled, topbar.component.css) visible at all. -->
        <app-topbar class="shell-toolbar" (logoClicked)="showSideNav()" [scrolled]="contentScrolled"
          *ngIf="mode === 'side' && !matchUrl('/signin')"></app-topbar>

        <!-- Mobile counterpart of .shell-toolbar above (PDT-35766): sticky on the same
             scroll container, navy surface matching the sidenav, logo + hamburger only —
             the back arrow lives in the content area below instead of this bar. -->
        <div class="mobile-shell-topbar" *ngIf="mode === 'over' && !matchUrl('/signin')">
          <button type="button" class="mobile-shell-topbar__logo-btn" aria-label="Open navigation menu"
            (click)="showSideNav()" *ngIf="dataManager.brandingReady && dataManager.logoUrl">
            <img src="{{dataManager.logoUrl }}" class="mobile-shell-topbar__logo" alt="Logo">
          </button>
          <button type="button" class="btn btn-link rounded-circle toggle_btn" aria-label="Open navigation menu"
            (click)="showSideNav()">
            <img src="../../../assets/images/accordian.svg" alt="">
          </button>
        </div>

        <div class="body-contain" id='body_contain'>
          <div class="row no-margin">
            <div class="col-md-12 no-padding">
              <button type="button" class="btn btn-link rounded-circle go_back mobile-back-btn"
                *ngIf="mode === 'over' && !matchUrl('/signin')" aria-label="Go back" (click)="goBack()">
                <img src="../../../assets/images/back.svg" alt="">
              </button>
              <router-outlet (activate)="onActivate(routerOutlet)"></router-outlet>
            </div>
          </div>
        </div>
        <div class="row no-margin" *ngIf="!matchUrl('/signin')">
          <div class="col-md-12 no-padding">
            <app-footer></app-footer>

          </div>
        </div>
      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>
</div>